import * as React from "react"

import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import { GlobalState } from "../../../../../../store"
import { itemSelector } from "../../../../../resources/adapters"
import { fetchItem } from "../../../../../resources/thunks"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    label: string
    customLabel: string
    itemId: number
}

export const Item = ({
    attributes,
    customLabel,
    label,
    itemId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const item = itemSelector.selectById(resources, itemId)

    React.useEffect(() => {
        if (!item) {
            dispatch(fetchItem(itemId))
        }
    }, [])

    if (!item) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (
        item.doesExist &&
        !!item.concept &&
        item.concept.doesExist &&
        !!item.concept.workspace &&
        item.concept.workspace.doesExist
    ) {
        const href = `workspace/${item.concept.workspace.id}/${item.concept.id}l/${item.id}`

        // we only show the title if there is no custom label
        const linkLabel = customLabel.length > 0 ? customLabel : item.title

        return <Link attributes={attributes} label={linkLabel} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default Item
